import { type ReactNode, useCallback, useState } from 'react';

import {
  BottomNavigation,
  MobileDrawer,
  MobileHeader,
} from '../components/mobile';

interface MobileLayoutProps {
  children: ReactNode;
}

export function MobileLayout({ children }: MobileLayoutProps) {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const handleOpenDrawer = useCallback(() => setIsDrawerOpen(true), []);
  const handleCloseDrawer = useCallback(() => setIsDrawerOpen(false), []);

  return (
    <div className="flex min-h-screen flex-col bg-surface-primary">
      <MobileHeader onMenuClick={handleOpenDrawer} />

      <main className="flex-1 overflow-auto pb-[var(--dashboard-bottom-nav-height)]">
        <div className="p-5 pb-6">{children}</div>
      </main>

      <BottomNavigation />

      <MobileDrawer isOpen={isDrawerOpen} onClose={handleCloseDrawer} />
    </div>
  );
}
